export function formatDate(dateString)
{
    if (!dateString) return '';
    try
    {
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        });
    }
    catch(error)
    {
        console.error('Error formatting date:', error);
        return 'Invalid Date';
    }
}
  
export function formatCurrency(number)
{
    if (typeof number !== 'number')
    {
        number = parseFloat(number);
        
        if (isNaN(number) === true)
        {
            return 'N/A';
        }
    }
    
    try
    {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: 'USD',
        }).format(number);
    }
    catch(error)
    {
        console.error('Error formatting currency:', error)
        return 'N/A';
    }
}

export function formatBoolean(bool)
{
    if (typeof bool !== 'boolean') return 'N/A';
    return bool ? 'Yes' : 'No';
}